import { render, staticRenderFns } from "./AiMockInterview.vue?vue&type=template&id=b4e81b8e"
import script from "./AiMockInterview.vue?vue&type=script&lang=js"
export * from "./AiMockInterview.vue?vue&type=script&lang=js"
import style0 from "./AiMockInterview.vue?vue&type=style&index=0&id=b4e81b8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports